import axios from '@/plugins/axios';
import { IStatsServerRepository, StatsServerFetchResponse } from '@/models/interface/Management/IStatsServerRepository';

export class StatsServerRepository implements IStatsServerRepository {
    async getStatsServerIndex(): Promise<StatsServerFetchResponse> {
        return await axios.get('/api/management/stats-server').catch(error => error.response || error);
    }
}
